var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard-component"},[_c('div',{staticClass:"simple-keyboard",class:_vm.id})])}
var staticRenderFns = []

export { render, staticRenderFns }